module.exports = __webpack_public_path__ + "fonts/sourcesansprosemibolditalic.6bb419eb.woff";